"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBar = void 0;
const vue_1 = require("vue");
const PlayerInfo_1 = require("./overview/PlayerInfo");
const PreferencesManager_1 = require("./PreferencesManager");
exports.TopBar = vue_1.default.component('top-bar', {
    props: {
        player: {
            type: Object,
        },
    },
    components: {
        PlayerInfo: PlayerInfo_1.PlayerInfo,
    },
    data: function () {
        return {
            componentKey: 0,
        };
    },
    methods: {
        forceRerender() {
            this.componentKey += 1;
        },
        toggleBar() {
            PreferencesManager_1.PreferencesManager.save('hide_top_bar', this.isExpanded(), true);
            this.forceRerender();
        },
        isExpanded() {
            return !PreferencesManager_1.PreferencesManager.loadBoolean('hide_top_bar');
        },
        formatCssClass() {
            const cssClasses = ['top-bar'];
            if (!this.isExpanded()) {
                cssClasses.push('top-bar-collapsed');
            }
            return cssClasses.join(' ');
        },
    },
    template: `
    <div :class="formatCssClass()" :key="componentKey">
      <PlayerInfo v-show="isExpanded()" :player="player" :activePlayer="player" actionLabel="" :playerIndex="0" :hideZeroTags="true"/>
      <div class="top-bar-collapser" v-on:click="toggleBar()">
        <img src="/assets/arrows/arrows_left.png">
      </div>
    </div>
  `,
});
//# sourceMappingURL=TopBar.js.map